import { currentMarket } from './market.js';

// Where Pro can be bought:
//   website, US             -> Stripe checkout
//   website, Australia      -> nowhere on the website: Australians buy through
//                              Google Play in the Android app (the website
//                              shows a "get it on Google Play" box instead)
//   Android app             -> Google Play billing (ZephyrBilling native plugin)
// An app build without Google Play billing (v138/v139) can't sell at all:
// Google Play requires its own billing for in-app purchases.
export function isNativeApp() {
    return !!window.Capacitor?.isNativePlatform?.();
}

export function hasPlayBilling() {
    return isNativeApp() && !!window.Capacitor?.isPluginAvailable?.('ZephyrBilling');
}

// 'stripe' | 'play' | 'play-link' (website pointing Australians to Google Play) | 'none'
export function purchaseChannel() {
    if (isNativeApp()) return hasPlayBilling() ? 'play' : 'none';
    return currentMarket() === 'AU' ? 'play-link' : 'stripe';
}

// Whether Subscribe / Upgrade prompts are shown here.
export function canPurchaseInApp() {
    return purchaseChannel() !== 'none';
}

// The website's pricing pages (Stripe, US$ prices) are never linked from
// inside the app -- Google Play doesn't allow pointing to other ways to pay.
// Elements with class "web-pricing-link" are hidden in the app.
export function showsWebPricing() {
    return !isNativeApp();
}
